import { FieldAPI, Metadata } from '@philips-internal/oswald-ui-components';

interface NursingInterventionsFields {
  field: FieldAPI;
  metadata?: Metadata;
}

interface AutocompleteValue {
  label: string;
  value: string;
}
interface ModalityAndInvasiveMechanicalType {
  cd: string;
  ds: string;
}

interface FormFields {
  attributeId: string;
  attributeName: string;
  value: string | number;
}

interface NursingInterventionSchedule {
  description?: string
  id : number
  itemCode: number
  key?: number
  label?: string
  prescriptionNumber: number
  scheduleSequence: number
  value?: number
  vitalSignsQt?: number
}

enum RespirationType {
  ESPONT = 'ESPONT',
  VMI = 'VMI',
  VMNI = 'VMNI'
}

enum InvasiveMechanicalType {
  CN = 'CN',
  TM  = 'TM',
  TP = 'TP',
  COT = 'COT'
}

export {
  FormFields,
  AutocompleteValue,
  InvasiveMechanicalType,
  NursingInterventionsFields,
  NursingInterventionSchedule,
  ModalityAndInvasiveMechanicalType,
  RespirationType
}